import MuiCard from "@mui/material/Card";
import type { CardProps as MuiCardProps } from "@mui/material/Card";
import type { SystemStyleObject, Theme } from "@mui/system";

export type CardProps = MuiCardProps;

export function Card({ children, sx }: CardProps) {
  return (
    <MuiCard sx={{ borderRadius: 4, ...(sx as SystemStyleObject<Theme>) }}>{children}</MuiCard>
  );
}
